"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePickerNew = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var moment_1 = __importDefault(require("moment"));
var react_datepicker_1 = __importDefault(require("react-datepicker"));
var styles = __importStar(require("./DatePickerNew.module.css"));
var DatePickerNew = (function (_super) {
    __extends(DatePickerNew, _super);
    function DatePickerNew(props) {
        var _this = _super.call(this, props) || this;
        _this.pdf = false;
        _this.handleChangeDate = function (date) {
            var _a = _this.props, id = _a.id, onChange = _a.onChange;
            onChange(id, date);
        };
        _this.pdf = document.body.classList.contains("pdf");
        return _this;
    }
    DatePickerNew.prototype.render = function () {
        var _a = this.props, json_data = _a.json_data, id = _a.id, _b = _a.errors, errors = _b === void 0 ? {} : _b, page = _a.page, classNameWrap = _a.classNameWrap, className = _a.className, readonly = _a.readonly, minDate = _a.minDate;
        var value = "";
        if (page)
            value = json_data[page][id];
        else
            value = json_data[id];
        var error = errors[id];
        if (json_data[id]) {
            value = (0, moment_1.default)(json_data[id]).format("MM/DD/YYYY");
        }
        var convertValue = value;
        if (!convertValue)
            convertValue = undefined;
        var classNameDateWrap = "c-datepicker";
        if (classNameWrap)
            classNameDateWrap += " ".concat(classNameWrap);
        return (React.createElement("div", { className: classNameDateWrap },
            React.createElement(react_datepicker_1.default, { id: id, selected: Date.parse(convertValue), onChange: this.handleChangeDate, className: className, readOnly: readonly, minDate: minDate && new Date(minDate) }),
            error && React.createElement("p", { className: styles.error },
                error,
                " ")));
    };
    return DatePickerNew;
}(react_1.Component));
exports.DatePickerNew = DatePickerNew;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGF0ZVBpY2tlck5ldy5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2NvbXBvbmVudHMvRGF0ZVBpY2tlci9EYXRlUGlja2VyTmV3LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDJDQUE4QjtBQUM5QiwrQkFBK0I7QUFDL0Isa0RBQTJCO0FBQzNCLHNFQUE4QztBQUM5QyxpRUFBb0Q7QUFjcEQ7SUFBbUMsaUNBQThCO0lBRzdELHVCQUFZLEtBQUs7UUFBakIsWUFDSSxrQkFBTSxLQUFLLENBQUMsU0FFZjtRQUxPLFNBQUcsR0FBRyxLQUFLLENBQUE7UUFPWCxzQkFBZ0IsR0FBRyxVQUFDLElBQUk7WUFDdEIsSUFBQSxLQUFpQixLQUFJLENBQUMsS0FBSyxFQUExQixFQUFFLFFBQUEsRUFBRSxRQUFRLGNBQWMsQ0FBQTtZQUNqQyxRQUFRLENBQUMsRUFBRSxFQUFFLElBQUksQ0FBQyxDQUFBO1FBQ3RCLENBQUMsQ0FBQTtRQU5HLEtBQUksQ0FBQyxHQUFHLEdBQUcsUUFBUSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsUUFBUSxDQUFDLEtBQUssQ0FBQyxDQUFBOztJQUN0RCxDQUFDO0lBT00sOEJBQU0sR0FBYjtRQUNVLElBQUEsS0FTRixJQUFJLENBQUMsS0FBSyxFQVJWLFNBQVMsZUFBQSxFQUNULEVBQUUsUUFBQSxFQUNGLGNBQVcsRUFBWCxNQUFNLG1CQUFHLEVBQUUsS0FBQSxFQUNYLElBQUksVUFBQSxFQUNKLGFBQWEsbUJBQUEsRUFDYixTQUFTLGVBQUEsRUFDVCxRQUFRLGNBQUEsRUFDUixPQUFPLGFBQ0csQ0FBQTtRQUNkLElBQUksS0FBSyxHQUFHLEVBQUUsQ0FBQTtRQUNkLElBQUksSUFBSTtZQUFFLEtBQUssR0FBRyxTQUFTLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRSxDQUFDLENBQUE7O1lBQ2hDLEtBQUssR0FBRyxTQUFTLENBQUMsRUFBRSxDQUFDLENBQUE7UUFDMUIsSUFBTSxLQUFLLEdBQUcsTUFBTSxDQUFDLEVBQUUsQ0FBQyxDQUFBO1FBRXhCLElBQUksU0FBUyxDQUFDLEVBQUUsQ0FBQyxFQUFFO1lBQ2YsS0FBSyxHQUFHLElBQUEsZ0JBQU0sRUFBQyxTQUFTLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsWUFBWSxDQUFDLENBQUE7U0FDckQ7UUFDRCxJQUFJLFlBQVksR0FBRyxLQUFLLENBQUE7UUFDeEIsSUFBSSxDQUFDLFlBQVk7WUFBRSxZQUFZLEdBQUcsU0FBUyxDQUFBO1FBQzNDLElBQUksaUJBQWlCLEdBQUcsY0FBYyxDQUFBO1FBQ3RDLElBQUksYUFBYTtZQUFFLGlCQUFpQixJQUFJLFdBQUksYUFBYSxDQUFFLENBQUE7UUFFM0QsT0FBTyxDQUNILDZCQUFLLFNBQVMsRUFBRSxpQkFBaUI7WUFDN0Isb0JBQUMsMEJBQWUsSUFDWixFQUFFLEVBQUUsRUFBRSxFQUNOLFFBQVEsRUFBRSxJQUFJLENBQUMsS0FBSyxDQUFDLFlBQVksQ0FBQyxFQUNsQyxRQUFRLEVBQUUsSUFBSSxDQUFDLGdCQUFnQixFQUMvQixTQUFTLEVBQUUsU0FBUyxFQUNwQixRQUFRLEVBQUUsUUFBUSxFQUNsQixPQUFPLEVBQUUsT0FBTyxJQUFJLElBQUksSUFBSSxDQUFDLE9BQU8sQ0FBQyxHQUN2QztZQUNELEtBQUssSUFBSSwyQkFBRyxTQUFTLEVBQUUsTUFBTSxDQUFDLEtBQUs7Z0JBQUcsS0FBSztvQkFBTSxDQUNoRCxDQUNULENBQUE7SUFDTCxDQUFDO0lBQ0wsb0JBQUM7QUFBRCxDQUFDLEFBbkRELENBQW1DLGlCQUFTLEdBbUQzQztBQW5EWSxzQ0FBYSJ9